import { Component, OnInit, Input, Output, EventEmitter, ElementRef, HostBinding } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { SelectableModel } from '../../models/selectable/selectable.model';
import { SelectableStylingModel } from '../../models/selectable/selectable-styling.model';
import { SelectableTemplates } from '../../templates/selectable.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Selectable Component</p>
 * <p>Selectable component can be Checkbox, Switch or Radio</p>
 * <pre>
 * <code>
 * import {{'{'}} SelectableModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} CheckboxStylingModel {{'}'}} from 'cedrus-fusion' (in case of checkbox)
 * <code><</code>cf-checkbox<code>></code><code><</code><code>/</code>cf-checkbox<code>></code>
 * <code><</code>cf-switch<code>></code><code><</code><code>/</code>cf-switch<code>></code>
 * <code><</code>cf-radio<code>></code><code><</code><code>/</code>cf-radio<code>></code>
 * </code>
 * </pre>
 */
export class CfSelectableComponent extends CfCoreComponent implements OnInit {
/**
 * @hidden
 */
notificationClickable = '';
/**
 * @hidden
 */
selected: boolean;
/**
 * @hidden
 */
hasNoItem = false;
/**
 * @hidden
 */
internalId: number;
/**
 * <pre>{{'{'}}
 *  display: boolean,	    // Default: true.
 *  disable: boolean,	    // Default: false.
 *  value: string,			  // Default: value.
 *  item: any,			      // Item can be a string or any object to be put along side the control.
 *  checked: boolean,			// Default: false.
 *  itemPosition: string	// Default: after.
 * {{'}'}}
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 * 	value: 'pizza',
 * 	item: 'Pizza',
 * 	checked: true,
 * 	itemPosition: 'after'
 * {{'}'}}
 * </pre>
 */
public properties: SelectableModel;
/**
 * <p> dynamicClass: function() -> string,  // Function that returns name of the class </p>
 * <p> class: string                        // Name of the css class selector </p>
 * <p> themeColor: string                   // primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 *  // Container surrounding the checkbox
 *  container:{{'{'}}
 *    dynamicClass,
 *    class
 *  {{'}'}},
 *  // md-checkbox
 *  button:{{'{'}}
 *    dynamicClass,
 *    class,
 *    themeColor
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 */
public styling: SelectableStylingModel;
/**
 * <p>The internal value of the selectable emitted when selected.</p>
 * <p>Default is <b>value</b></p>
 * @param {?} value
 * @return {?}
 */
set value(value: string) { this.properties.value = value; }
/**
 * <p>Item can be a label or any other object based on the html template passed to the selectable</p>
 * @param {?} value
 * @return {?}
 */
set item(value: any) { this.properties.item = value; }
/**
 * <p>Checked or not checked. Double binded variable to get or set the checked value of the selectable.</p>
 * <p>Default: false</p>
 * @return {?}
 */
get checked() { return this.selected; }
/**
 * <p>Item Position relative to the control. Can be: before or after. Default: after.</p>
 * @param {?} value
 * @return {?}
 */
set itemPosition(value: string) { this.properties.itemPosition = value; }
/**
 * @hidden
 */
checkedChange = new EventEmitter();
/**
 * @hidden
 */
clicked = new EventEmitter();
/**
 * @hidden
 * @param {?} val
 * @return {?}
 */
set checked(val) {
    this.selected = val;
    this.checkedChange.emit(this.selected);
    if (this.properties != null) { this.properties.checked = this.selected; }
  }
/**
 * @hidden
 * @param {?} notification
 * @return {?}
 */
cfNotificationAction(notification) { this.notificationAction.emit(notification); }
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new SelectableModel();
    this.styling = new SelectableStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    super.ngOnInit();
    this.getMyTemplate('selectable', SelectableTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'SELECTABLE').then(sampler => {
        if (this.notificationAction.observers.length > 0) { this.notificationClickable = 'notification-clickable'; }
        // console.log('SELECTABLE', this);
      });
    });
  }
/**
 * @hidden
 * @return {?}
 */
notifyGroup() { this.clicked.emit({ 'id': this.internalId, 'value': this.selected }); }
/**
 * @hidden
 * @param {?} val
 * @return {?}
 */
updateFromGroup(val: boolean) { this.checked = val; }
/**
 * @hidden
 * @return {?}
 */
ifHasItem() { this.hasNoItem = this.properties.item && this.properties.item !== '' ? false : true; }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-selectable',
  template: "<ng-content></ng-content>",
  styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notificationClickable': [{ type: HostBinding, args: ['class', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'value': [{ type: Input, args: ['value', ] },],
'item': [{ type: Input, args: ['item', ] },],
'checked': [{ type: Input },],
'itemPosition': [{ type: Input, args: ['itemPosition', ] },],
'checkedChange': [{ type: Output },],
'clicked': [{ type: Output },],
};
}

function CfSelectableComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfSelectableComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfSelectableComponent.ctorParameters;
/** @type {?} */
CfSelectableComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfSelectableComponent.prototype.notificationClickable;
/**
 * @hidden
 * @type {?}
 */
CfSelectableComponent.prototype.selected;
/**
 * @hidden
 * @type {?}
 */
CfSelectableComponent.prototype.hasNoItem;
/**
 * @hidden
 * @type {?}
 */
CfSelectableComponent.prototype.internalId;
/**
 * <pre>{{'{'}}
 *  display: boolean,	    // Default: true.
 *  disable: boolean,	    // Default: false.
 *  value: string,			  // Default: value.
 *  item: any,			      // Item can be a string or any object to be put along side the control.
 *  checked: boolean,			// Default: false.
 *  itemPosition: string	// Default: after.
 * {{'}'}}
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 * 	value: 'pizza',
 * 	item: 'Pizza',
 * 	checked: true,
 * 	itemPosition: 'after'
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfSelectableComponent.prototype.properties;
/**
 * <p> dynamicClass: function() -> string,  // Function that returns name of the class </p>
 * <p> class: string                        // Name of the css class selector </p>
 * <p> themeColor: string                   // primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 *  // Container surrounding the checkbox
 *  container:{{'{'}}
 *    dynamicClass,
 *    class
 *  {{'}'}},
 *  // md-checkbox
 *  button:{{'{'}}
 *    dynamicClass,
 *    class,
 *    themeColor
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfSelectableComponent.prototype.styling;
/**
 * @hidden
 * @type {?}
 */
CfSelectableComponent.prototype.checkedChange;
/**
 * @hidden
 * @type {?}
 */
CfSelectableComponent.prototype.clicked;
/** @type {?} */
CfSelectableComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
